export const getLeadActivityAttributes = `
  query ActivityAttributes($activityId: Int!) {
    activityAttribute(activityId: $activityId) {
      id
      key: schemaName
      value: attributeName
      dataType
    }
  }
`;

export type LeadActivityAttribute = {
  id: number;
  key: string;
  value: string;
  dataType: string;
};

export type LeadActivityAttributesResponse = {
  activityAttribute: LeadActivityAttribute[];
};
